module.exports = __webpack_public_path__ + "static/img/physical_harm_2.32c3d658.png";